export const SidebarIdGlobalIssuesSettings = 'GLOBAL_ISSUES_SETTINGS' as const;
